<template>
    <div class='common-tips'>
        <transition name="drop">
            <div class="tips-body" v-if="isShow">
                <div class="tips-text">{{text}}</div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'tips',
        components: {},
        data(){
            return {
                text: 'hello',
                isShow: false,
            }
        },
        
        created(){},

        methods: {
            show (params){  //初始化参数
                this.text = params.text;
                this.isShow = true;
                setTimeout(() => {
                    this.isShow = false;
                }, params.time)
            },
        },

        mounted(){}
    }
</script>

<style lang='less' scoped src="../style"></style>

